import {
  AlignmentType, ImageRun,
  Paragraph,
  patchDocument,
  PatchType,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign
} from "docx";

export default {
  methods: {
    async patchInvoiceAct(file, params, completion) {
      const worksTable = this.createWorksTable(params);
      const fileName = `Акт № ${params.actNumber} от ${params.actDate}`;
      let accountNumber = `счёта № ${params. invoiceNumber} от ${params.invoiceDate}`;
      if (params.actContract !== '') {
        accountNumber = `договора № ${params. actContract}`;
      }

      patchDocument(file,{
        keepOriginalStyles: false,
        patches: {
          actTitle: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: `АКТ № ${params.actNumber} от ${params.actDate}`})],
          },
          town: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: params.actTown})],
          },
          date: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: params.actDate})],
          },
          accountNumber: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: accountNumber})],
          },
          accountNumber2: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: "Оплата производится в соответствии с условиями " + accountNumber})],
          },
          organizationName: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: params.organization.name})],
          },
          organizationNumber: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: "ИНН " + params.organization.inn})],
          },
          organizationFullName: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: params.organization.full_name})],
          },
          customerName: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: params.customer.name})],
          },
          customerFullName: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: params.customer.full_name})],
          },
          customerNumber: {
            type: PatchType.PARAGRAPH,
            children: [new TextRun({text: params.customer.inn})],
          },
          directorSign: {
            type: PatchType.PARAGRAPH,
            children: [
              this.getImageOrText(
                params.director.sign.image,
                {width: 34 * 2, height: 16 *2 },
                params.director.sign.name
              ),
            ],
          },
          organizationStamp: {
            type: PatchType.PARAGRAPH,
            children: [
              this.getImageOrText(
                params.stamp.image,
                {width: 40 * 2, height: 40 * 2 },
                params.stamp.name
              ),
            ],
          },
          worksTable: worksTable,
        }
      }).then((doc) => {
        completion(doc, fileName);
      });
    },
    // Для таблиц переопределяем шрифт, так как по умолчанию подставляется Times New Roman, 12
    getTextRun(text, bold = false) {
      return new TextRun({
        text: text,
        font: "Arial",
        bold: bold,
        size: 8*2, // TODO: Почему увеличивается в 2 раза пока не понятно
      })
    },
    // Создаем таблицу с работами
    createWorksTable(params) {
      const works = params.works;
      const total = params.total;

      const headerRow = new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  this.getTextRun("№"),
                ],
                alignment: AlignmentType.CENTER,
              })
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                  this.getTextRun("Выполненные работы / Оказанные услуги"),
                ],
              })
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  this.getTextRun("Цена"),
                ],
                alignment: AlignmentType.CENTER,
              })
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  this.getTextRun("Кол-во"),
                ],
                alignment: AlignmentType.CENTER,
              })
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  this.getTextRun("Ед. изм."),
                ],
                alignment: AlignmentType.CENTER,
              })
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  this.getTextRun("НДС"),
                ],
                alignment: AlignmentType.CENTER,
              })
            ],
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  this.getTextRun("Сумма, руб."),
                ],
                alignment: AlignmentType.CENTER,
              })
            ],
          }),
        ],
      });

      const bodyRows = works.map(function (work) {
        return new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    this.getTextRun(work.sort_index),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    this.getTextRun(work.name),
                  ],
                }),
              ],
              verticalAlign: VerticalAlign.TOP,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    this.getTextRun(work.price),
                  ],
                  alignment: AlignmentType.RIGHT,
                }),
              ],
              verticalAlign: VerticalAlign.TOP,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    this.getTextRun(work.count),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.TOP,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    this.getTextRun(work.unitName),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.TOP,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    this.getTextRun(work.nds),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: VerticalAlign.TOP,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    this.getTextRun(work.sum),
                  ],
                  alignment: AlignmentType.RIGHT,
                }),
              ],
              verticalAlign: VerticalAlign.TOP,
            }),
          ],
        })
      }.bind(this));

      let ndsPrice = "";
      let ndsText = "без НДС";
      let footerPaymentText = `Оплата по счету № ${params.invoiceNumber} от ${params.invoiceDate} (${ndsText})`;
      let footerTotalText = `Итого (${ndsText})`;

      if (total.nds > 0) {
        ndsText = `${total.nds.toString()}`  + "%";
        ndsPrice = `=${this.priceFormat((total.sum * total.nds) / 100)} руб.:` ;

        footerTotalText = `Итого, в т. ч. НДС (${ndsText})${ndsPrice}`;
        footerPaymentText = `Оплата по счету № ${params.invoiceNumber} от ${params.invoiceDate}, в т. ч. НДС (${ndsText})${ndsPrice} руб.`;
      }

      const totalRow = new TableRow({
        children: [
          new TableCell({
            columnSpan: 6,
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: footerTotalText,
                    font: "Arial",
                    size: 8*2, // TODO: Почему увеличивается в 2 раза пока не понятно
                  }),
                ],
                alignment: AlignmentType.RIGHT,
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: total.sumText,
                    font: "Arial",
                    size: 8*2, // TODO: Почему увеличивается в 2 раза пока не понятно
                  }),
                ],
                alignment: AlignmentType.RIGHT,
              }),
            ],
            verticalAlign: VerticalAlign.TOP,
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: total.sum,
                    font: "Arial",
                    size: 8*2, // TODO: Почему увеличивается в 2 раза пока не понятно
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.RIGHT,
              }),
            ],
            verticalAlign: VerticalAlign.TOP,
          }),
        ],
      })
      return {
        type: PatchType.DOCUMENT,
        children: [
          new Table({
            columnWidths: [500, 5000, 1000, 500, 700, 500, 2000],
            rows: [
              headerRow,
              ...bodyRows,
              totalRow,
            ],
          }),
        ],
      }
    },
    getImageOrText(data, transformation, text = "") {
      if (data !== null) {
        return new ImageRun({
          data: data,
          transformation: transformation,
        });
      }

      return this.getTextRun(text);
    },
    makeRequisites(org) {
      let result = [];

      const name = this.makeRequisitesParagraph(null, org.name, true);
      if (name) { result.push(name); }

      const address = this.makeRequisitesParagraph(null, org.address);
      if (address) { result.push(address); }

      let innText = org.inn;
      if (org.kpp !== '') {
        innText = org.inn + " / " + org.kpp;
      }
      const inn = this.makeRequisitesParagraph("ИНН/КПП", innText);
      if (inn) { result.push(inn); }

      const ogrn = this.makeRequisitesParagraph("ОГРН", org.ogrn);
      if (ogrn) { result.push(ogrn); }

      const checking_account = this.makeRequisitesParagraph("Расчетный счёт", org.checking_account);
      if (checking_account) { result.push(checking_account); }

      const bank = this.makeRequisitesParagraph(null, org.bank);
      if (bank) { result.push(bank); }

      const corr = this.makeRequisitesParagraph("Кор. счёт", org.cor_account);
      if (corr) { result.push(corr); }

      const bik = this.makeRequisitesParagraph("БИК", org.bik);
      if (bik) { result.push(bik); }

      return result;
    },
    makeRequisitesParagraph(key, value, bold) {
      if (value === '') {
        return null;
      }
      let text = value;
      if (key !== null) {
        text = key + " " + value;
      }

      return new Paragraph({
        children: [
          this.getTextRun(text, bold)
        ],
        alignment: AlignmentType.LEFT,
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/utilites/invoiceActPatcher.js